
export class ModelIncludeModel {
  id: string;
  modelNumber: string;
  label: string;
  constructor(data?) {
    const modelincludeData = data || {};
    this.id = modelincludeData.id;
    this.modelNumber = modelincludeData.modelNumber;
    this.label = modelincludeData.label;
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/models/model-include.model.ts